module.exports = __webpack_public_path__ + "static/media/getTicket.273353fb.jpg";